import React, { Component } from 'react';
import Search from '../../../components/Search';
import DataTable from '../../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../../actions/search';
import {withRouter} from 'react-router';
import { setSearchScope } from '../../../helpers';

class AddressOverview extends Component {

	constructor(props,context) {
        super(props,context);


        const clientId = this.props.match.params.clientId;
        if(clientId) {
            // -- get client from state
            const client = this.props.clientData.data.find(e => e.id === clientId);
            this.state = {
                clientAddresses: client
            }
        }

    }

    componentDidUpdate(prevProps) {
        if(prevProps.clientData.data != this.props.clientData.data) {
            const clientId = this.props.match.params.clientId;
            if(clientId) {
                // -- get client from state
                const client = this.props.clientData.data.find(e => e.id === clientId);
                this.state = {
                    clientAddresses: client
                }

                this.props.updateSearchData(client.addresses)
            }
        }
    }

    findFilesInAddress(address) {
        if(address) {

            const allAddress = this.props.clientData.allAddresses.find(e => e.dp_address_id === address.dp_address_id);
            if(allAddress.files) {
                if(allAddress.files.length) {
                    return true;
                }
            }
        }

        return false;
    }

	componentWillMount() {
		
        // -- find addresses

        this.columns = [{
                  Header: 'Adres naam',
                  accessor: 'vve_address_name',
            },{
                  Header: 'Straat',
                  accessor: 'street',
            },{
                  Header: 'Postcode',
                  accessor: 'zipcode',
            },{
                  Header: 'Stad',
                  accessor: 'city',
            }]

            this.additionalColumns = [{
                Header: 'Actief',
                accessor: 'is_active',
                Cell: props => <span>{props.value === '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
            },{
                Header: '#',
                accessor: 'dp_address_id',
                Cell: props => <span className={props.row._original.user_id ? props.row._original.user_name ? '' : 'disabled' : 'disabled'}><i className="fa fa-plus"></i> <a href={'/#/files/add/address/'+props.value}>Bestand toevoegen</a></span>
            },{
                Header: '#',
                accessor: 'dp_address_id',
                Cell: props => <span className={props.row._original.files ? props.row._original.files.length ? '' : 'disabled' : 'disabled'} ><i className="fa fa-eye"></i> <a href={'/#/addresses/view/'+props.value}>Bestanden bekijken</a></span>
            }]


        this.props.updateSearchData(this.state.clientAddresses.addresses)
        

  	}

	render() {
        const filterValues = {
            isActive : {
                name: 'Is Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '1'
            },
            isNotActive : {
                name: 'Niet Actief',
                type: 'checkbox',
                key: 'is_active',
                value : '0'
            }
        }
        return (

            <div className="animated fadeIn">

                <Card>
                <CardHeader>
                <Search ignoreSearchScope={true} filters={filterValues} data={this.state.clientAddresses.addresses} keys_to_filter={['vve_address_name','street', 'zipcode', 'city']}/>
                </CardHeader>
                    <CardBody>
                        <CardTitle><i className="fa fa-align-justify"></i> Adressen overzicht</CardTitle>
                        <DataTable additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.state.clientAddresses.addresses} columns={this.columns} />
                    </CardBody>
                </Card>

            </div>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        clientData: state.ClientDataReducer,
        searchData: state.SearchDataReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddressOverview))



// WEBPACK FOOTER //
// ./src/views/Clients/Addresses/index.js